<app-orders-nav *ngIf="from == 'orders'" [activeMenuItem]="'annual-fees-paid'"></app-orders-nav>

<mat-card class="content-card">

  <h2>Annual Fees</h2>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel" [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
        <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel" [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
        <mat-form-field class="date-filter-field">
          <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
            <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">
              {{dateFilter.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select placeholder="Annual fee status" [(ngModel)]="table.filters.additionalValue1">
            <mat-option value="created">Created</mat-option>
            <mat-option value="due">Due</mat-option>
            <mat-option value="invoice_created">Invoice created</mat-option>
            <mat-option value="in_collection">In Collection</mat-option>
            <mat-option value="paid">Paid in full</mat-option>
            <mat-option value="partially_paid">Paid partially</mat-option>
            <div class="select-separator"></div>
            <mat-option value="paid_on_time">Paid on time</mat-option>


          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Brand</mat-label>
          <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" (ngModelChange)="onCompanyChange($event)" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Product</mat-label>
          <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.productsFilter" multiple>
            <mat-option [style]="product.active ? '' : 'color: grey;'" *ngFor="let product of productsToShow" [value]="product.id">{{product.internalName}}<span *ngIf="!product.active" style="color: red;"> (I)</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()" [disabled]="startDateFilter.invalid || endDateFilter.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>


  <app-mat-table-generator #table
                           tableName="annualFeesTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           (clearingFilters)="checkAllButton()"
                           [dialogRemoveText]="dialogRemoveText"
                           [saveFilters]=true


  >
  </app-mat-table-generator>
</mat-card>
